import fetch from '@/utils/fetch'
import {wymsFetch} from '@/utils/fetch'

/**
 * 统一处理请求参数
 * */
function filterURLSearchParams(args = {}) {
  const params = new URLSearchParams();
  Object.keys(args).forEach(key => {
    params.append(key, args[key])
  });
  return params
}

/**
 * 刷权限
 * */
/**
 * 应用列表
 * */
export function listModule(args) {
  return wymsFetch({
    url: 'srp/listModule',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 角色列表
 * */
export function lisRole(args) {
  return wymsFetch({
    url: 'srp/lisRole',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增模块角色权限
 * */
export function addModuleRolePerm(args) {
  return wymsFetch({
    url: 'srp/addModuleRolePerm',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 删除模块角色权限
 * */
export function delModuleRolePerm(args) {
  return wymsFetch({
    url: 'srp/delModuleRolePerm',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 重置学校应用权限
 * */
export function resetPermission(args) {
  return wymsFetch({
    url: 'srp/resetPermission',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询权限树结构
 * */
export function queryPermissionTree(args) {
  return wymsFetch({
    url: 'permission/queryPermissionTree',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * redisKey列表页
 * */
export function indexScan(args) {
  return wymsFetch({
    url: 'redis/indexScan',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * redis 详情
 * */
export function redisDetail(args) {
  return wymsFetch({
    url: 'redis/detail',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * redis 删除
 * */
export function redisDelete(args) {
  return wymsFetch({
    headers: {
      'content-type': 'application/json'
    },
    url: 'redis/delete',
    method: 'POST',
    data: JSON.stringify(args.keyList)
  })
}

/**
 * 模糊删除
 * */
export function blurryDelete(args) {
  return wymsFetch({
    url: 'redis/blurryDelete',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 单点登录定时器
 * */
export function getTimerUrl(args) {
  return wymsFetch({
    url: 'wxcepJob/index',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

export function tencentCloudLogin(args) {
    return wymsFetch({
        url: 'tencentCloud/login',
        method: 'POST',
        data: filterURLSearchParams(args)
    })

}



// WEBPACK FOOTER //
// ./src/api/commonTool.js